import { useEffect, useState } from "react";
import "./App.css";
import Content from "./components/Content/Content";
import Navbar from "./components/Navbar";
import Player from "./components/player/Player";
import { Songs } from "./Context/ContextApp";
import ListSongs from "./data/songs.json";
function App() {
  const [song, setSong] = useState({});
  useEffect(() => {
    handleSelectSong(0);
  }, []);
  const handleSelectSong = (IdSong) => {
    const song = ListSongs.find((song) => song.id === IdSong) || ListSongs[0];
    setSong(song);
  };
  return (
    <Songs.Provider value={{ song, ListSongs, handleSelectSong }}>
      <div className="App">
        <Navbar />
        <Content />
        <Player />
      </div>
    </Songs.Provider>
  );
}

export default App;
